/* eslint-disable */
/* TODO: If you edit this file remove eslint-disable and fix linting errors in this file. */
require('../../core/scripts/time/time.service');
require('../../core/scripts/time/timeAgoSeconds.filter');

/*Timed sync*/
require('../../core/scripts/timedSync/timedSync.service');
